import { Button } from "@/components/common/Button";
import UserInfo from "@/components/layout/home/UserInfo";
import ConnectedWallet from "@/components/layout/settings/ConnectedWallet";
import Language from "@/components/layout/settings/Language";
import Policy from "@/components/layout/settings/Policy";
import { WalletConnect } from "@/components/layout/settings/WalletConnect";
import { logout } from "@/modules/auth";
import WebApp from "@twa-dev/sdk";

const Settings = () => {
  const isMiniApp = !!WebApp.initData;

  return (
    <div className="flex-1 flex flex-col justify-between items-center">
      <div className="flex w-full flex-col gap-3 px-4">
        <div className="flex w-full bg-bg rounded-[0.75rem]">
          <UserInfo />
        </div>

        <ConnectedWallet />

        {!isMiniApp && <WalletConnect />}

        <Language />

        <Policy />

        {!isMiniApp && (
          <Button
            onClick={async () => {
              await logout();

              window.location.reload();
            }}
            text="Logout"
            mode="bezeled"
          />
        )}
      </div>
    </div>
  );
};

export default Settings;
